"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryKarmaResponse = exports.QueryKarmaRequest = exports.QueryNegentropyResponse = exports.QueryNegentropyRequest = exports.QueryNegentropyParticleResponse = exports.QueryNegentropyPartilceRequest = exports.QueryLinkExistResponse = exports.QueryIsAnyLinkExistRequest = exports.QueryIsLinkExistRequest = exports.QueryTopRequest = exports.QuerySearchResponse = exports.QuerySearchRequest = exports.QueryRankResponse = exports.QueryRankRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pagination_1 = require("./pagination");
const types_1 = require("./types");
exports.protobufPackage = "cyber.rank.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return { params: undefined };
}
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            types_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = types_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { params: isSet(object.params) ? types_1.Params.fromJSON(object.params) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? types_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = (object.params !== undefined && object.params !== null)
            ? types_1.Params.fromPartial(object.params)
            : undefined;
        return message;
    },
};
function createBaseQueryRankRequest() {
    return { particle: "" };
}
exports.QueryRankRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.particle !== "") {
            writer.uint32(10).string(message.particle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRankRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.particle = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { particle: isSet(object.particle) ? String(object.particle) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.particle !== undefined && (obj.particle = message.particle);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRankRequest();
        message.particle = object.particle ?? "";
        return message;
    },
};
function createBaseQueryRankResponse() {
    return { rank: long_1.default.UZERO };
}
exports.QueryRankResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.rank.isZero()) {
            writer.uint32(8).uint64(message.rank);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryRankResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rank = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { rank: isSet(object.rank) ? long_1.default.fromValue(object.rank) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.rank !== undefined && (obj.rank = (message.rank || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryRankResponse();
        message.rank = (object.rank !== undefined && object.rank !== null) ? long_1.default.fromValue(object.rank) : long_1.default.UZERO;
        return message;
    },
};
function createBaseQuerySearchRequest() {
    return { particle: "", pagination: undefined };
}
exports.QuerySearchRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.particle !== "") {
            writer.uint32(10).string(message.particle);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySearchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.particle = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            particle: isSet(object.particle) ? String(object.particle) : "",
            pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        message.particle !== undefined && (obj.particle = message.particle);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySearchRequest();
        message.particle = object.particle ?? "";
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PageRequest.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQuerySearchResponse() {
    return { result: [], pagination: undefined };
}
exports.QuerySearchResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.result) {
            types_1.RankedParticle.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySearchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result.push(types_1.RankedParticle.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            result: Array.isArray(object?.result) ? object.result.map((e) => types_1.RankedParticle.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? pagination_1.PageResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.result) {
            obj.result = message.result.map((e) => e ? types_1.RankedParticle.toJSON(e) : undefined);
        }
        else {
            obj.result = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySearchResponse();
        message.result = object.result?.map((e) => types_1.RankedParticle.fromPartial(e)) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PageResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQueryTopRequest() {
    return { pagination: undefined };
}
exports.QueryTopRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryTopRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { pagination: isSet(object.pagination) ? pagination_1.PageRequest.fromJSON(object.pagination) : undefined };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination ? pagination_1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryTopRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PageRequest.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseQueryIsLinkExistRequest() {
    return { from: "", to: "", address: "" };
}
exports.QueryIsLinkExistRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.from !== "") {
            writer.uint32(10).string(message.from);
        }
        if (message.to !== "") {
            writer.uint32(18).string(message.to);
        }
        if (message.address !== "") {
            writer.uint32(26).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIsLinkExistRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.from = reader.string();
                    break;
                case 2:
                    message.to = reader.string();
                    break;
                case 3:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            from: isSet(object.from) ? String(object.from) : "",
            to: isSet(object.to) ? String(object.to) : "",
            address: isSet(object.address) ? String(object.address) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        message.from !== undefined && (obj.from = message.from);
        message.to !== undefined && (obj.to = message.to);
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryIsLinkExistRequest();
        message.from = object.from ?? "";
        message.to = object.to ?? "";
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseQueryIsAnyLinkExistRequest() {
    return { from: "", to: "" };
}
exports.QueryIsAnyLinkExistRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.from !== "") {
            writer.uint32(10).string(message.from);
        }
        if (message.to !== "") {
            writer.uint32(18).string(message.to);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIsAnyLinkExistRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.from = reader.string();
                    break;
                case 2:
                    message.to = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { from: isSet(object.from) ? String(object.from) : "", to: isSet(object.to) ? String(object.to) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.from !== undefined && (obj.from = message.from);
        message.to !== undefined && (obj.to = message.to);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryIsAnyLinkExistRequest();
        message.from = object.from ?? "";
        message.to = object.to ?? "";
        return message;
    },
};
function createBaseQueryLinkExistResponse() {
    return { exist: false };
}
exports.QueryLinkExistResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exist === true) {
            writer.uint32(8).bool(message.exist);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryLinkExistResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { exist: isSet(object.exist) ? Boolean(object.exist) : false };
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryLinkExistResponse();
        message.exist = object.exist ?? false;
        return message;
    },
};
function createBaseQueryNegentropyPartilceRequest() {
    return { particle: "" };
}
exports.QueryNegentropyPartilceRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.particle !== "") {
            writer.uint32(10).string(message.particle);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNegentropyPartilceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.particle = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { particle: isSet(object.particle) ? String(object.particle) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.particle !== undefined && (obj.particle = message.particle);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryNegentropyPartilceRequest();
        message.particle = object.particle ?? "";
        return message;
    },
};
function createBaseQueryNegentropyParticleResponse() {
    return { entropy: long_1.default.UZERO };
}
exports.QueryNegentropyParticleResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.entropy.isZero()) {
            writer.uint32(8).uint64(message.entropy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNegentropyParticleResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entropy = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { entropy: isSet(object.entropy) ? long_1.default.fromValue(object.entropy) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.entropy !== undefined && (obj.entropy = (message.entropy || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryNegentropyParticleResponse();
        message.entropy = (object.entropy !== undefined && object.entropy !== null)
            ? long_1.default.fromValue(object.entropy)
            : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryNegentropyRequest() {
    return {};
}
exports.QueryNegentropyRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNegentropyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryNegentropyRequest();
        return message;
    },
};
function createBaseQueryNegentropyResponse() {
    return { negentropy: long_1.default.UZERO };
}
exports.QueryNegentropyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.negentropy.isZero()) {
            writer.uint32(8).uint64(message.negentropy);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNegentropyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.negentropy = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { negentropy: isSet(object.negentropy) ? long_1.default.fromValue(object.negentropy) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.negentropy !== undefined && (obj.negentropy = (message.negentropy || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryNegentropyResponse();
        message.negentropy = (object.negentropy !== undefined && object.negentropy !== null)
            ? long_1.default.fromValue(object.negentropy)
            : long_1.default.UZERO;
        return message;
    },
};
function createBaseQueryKarmaRequest() {
    return { neuron: "" };
}
exports.QueryKarmaRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.neuron !== "") {
            writer.uint32(10).string(message.neuron);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryKarmaRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.neuron = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { neuron: isSet(object.neuron) ? String(object.neuron) : "" };
    },
    toJSON(message) {
        const obj = {};
        message.neuron !== undefined && (obj.neuron = message.neuron);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryKarmaRequest();
        message.neuron = object.neuron ?? "";
        return message;
    },
};
function createBaseQueryKarmaResponse() {
    return { karma: long_1.default.UZERO };
}
exports.QueryKarmaResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.karma.isZero()) {
            writer.uint32(8).uint64(message.karma);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryKarmaResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.karma = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return { karma: isSet(object.karma) ? long_1.default.fromValue(object.karma) : long_1.default.UZERO };
    },
    toJSON(message) {
        const obj = {};
        message.karma !== undefined && (obj.karma = (message.karma || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryKarmaResponse();
        message.karma = (object.karma !== undefined && object.karma !== null) ? long_1.default.fromValue(object.karma) : long_1.default.UZERO;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || "cyber.rank.v1beta1.Query";
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Rank = this.Rank.bind(this);
        this.Search = this.Search.bind(this);
        this.Backlinks = this.Backlinks.bind(this);
        this.Top = this.Top.bind(this);
        this.IsLinkExist = this.IsLinkExist.bind(this);
        this.IsAnyLinkExist = this.IsAnyLinkExist.bind(this);
        this.ParticleNegentropy = this.ParticleNegentropy.bind(this);
        this.Negentropy = this.Negentropy.bind(this);
        this.Karma = this.Karma.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Rank(request) {
        const data = exports.QueryRankRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Rank", data);
        return promise.then((data) => exports.QueryRankResponse.decode(new minimal_1.default.Reader(data)));
    }
    Search(request) {
        const data = exports.QuerySearchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Search", data);
        return promise.then((data) => exports.QuerySearchResponse.decode(new minimal_1.default.Reader(data)));
    }
    Backlinks(request) {
        const data = exports.QuerySearchRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Backlinks", data);
        return promise.then((data) => exports.QuerySearchResponse.decode(new minimal_1.default.Reader(data)));
    }
    Top(request) {
        const data = exports.QueryTopRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Top", data);
        return promise.then((data) => exports.QuerySearchResponse.decode(new minimal_1.default.Reader(data)));
    }
    IsLinkExist(request) {
        const data = exports.QueryIsLinkExistRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "IsLinkExist", data);
        return promise.then((data) => exports.QueryLinkExistResponse.decode(new minimal_1.default.Reader(data)));
    }
    IsAnyLinkExist(request) {
        const data = exports.QueryIsAnyLinkExistRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "IsAnyLinkExist", data);
        return promise.then((data) => exports.QueryLinkExistResponse.decode(new minimal_1.default.Reader(data)));
    }
    ParticleNegentropy(request) {
        const data = exports.QueryNegentropyPartilceRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ParticleNegentropy", data);
        return promise.then((data) => exports.QueryNegentropyParticleResponse.decode(new minimal_1.default.Reader(data)));
    }
    Negentropy(request) {
        const data = exports.QueryNegentropyRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Negentropy", data);
        return promise.then((data) => exports.QueryNegentropyResponse.decode(new minimal_1.default.Reader(data)));
    }
    Karma(request) {
        const data = exports.QueryKarmaRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Karma", data);
        return promise.then((data) => exports.QueryKarmaResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=query.js.map